import { i18n } from '@lingui/core';
import { catalogs } from './catalogs';
import { type AppLocale, DEFAULT_LOCALE, isAppLocale } from './locales';

let catalogsLoaded = false;

/**
 * Activate a language on the shared Lingui instance — the one the macros compile to.
 * Registers every catalog on first use. Synchronous and idempotent, so hosts can call it
 * before the first render and again on every change.
 */
export function activateLocale(locale: AppLocale): void {
  if (!catalogsLoaded) {
    i18n.load({ ...catalogs });
    catalogsLoaded = true;
  }
  if (i18n.locale !== locale) i18n.activate(locale);
}

/** The active locale, or en-US before anything was activated. */
export function activeLocale(): AppLocale {
  return isAppLocale(i18n.locale) ? i18n.locale : DEFAULT_LOCALE;
}

export { i18n };
